/**
 * Created by Mark on 04/05/2017.
 */



import React   from 'react';
import Layout  from '../../components/layouts/standard-page.js';
import {Button , OverlayTrigger , Tooltip} from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Link , hashHistory} from 'react-router'
import Card from '../../components/card.js';
import CardHead from '../../components/card-header.js';
import CardBody   from '../../components/card-body.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Wizard from '../../components/wizard/wizard.js';
import Steps from '../../components/wizard/homework-steps';

export default class HomeworkBuilder extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {assignment:false , steps:Steps}

    }


    onModify(steps){
        this.setState({steps:steps});
    }

    render(){

        var steps

        return (<Layout>
            <Wizard onModify={this.onModify.bind(this)} name="" stepsNavigation={true} steps={this.state.steps} />
                </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/new_screens/homework-builder.js